import { useSessionStore } from '@/stores'
import { isEmbedded } from '@utils/iframe'
import { useEmbedConfig } from '@/hooks/useEmbedConfig'
import { getPortalLogo } from '../utils/themeTokens'

const OmpHeader = () => {
  const campaign = useSessionStore(s => s.campaign) as any
  const { showHeader } = useEmbedConfig()
  const { desktop: logo, mobile: mobileLogo } = getPortalLogo(campaign)

  if (isEmbedded() && !showHeader) {
    return null
  }

  return (
    <header className="omp-header">
      {logo ? (
        <div className="omp-header-logo">
          <img src={mobileLogo || logo} alt={campaign?.name || ''} className="sm:hidden" />
          <img src={logo} alt={campaign?.name || ''} className="hidden sm:block" />
        </div>
      ) : (
        <div className="omp-header-logo omp-header-logo-text">{campaign?.name || 'LOGO'}</div>
      )}
    </header>
  )
}

export default OmpHeader
